var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmailYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#f28705;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1244 -730)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1252.446 739.937)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.49,4H15.414A1.5,1.5,0,0,1,16.9,5.49v8.943a1.5,1.5,0,0,1-1.49,1.49H3.49A1.5,1.5,0,0,1,2,14.433V5.49A1.5,1.5,0,0,1,3.49,4Z",
    transform: "translate(-2 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.9,6,9.452,11.217,2,6",
    transform: "translate(-2 -4.51)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 32,
    height: 32,
    transform: "translate(1244 730)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailYellow);
export default __webpack_public_path__ + "static/media/Icon_Email_Yellow.93e57d6f44573a10c4db3cab4151c4b7.svg";
export { ForwardRef as ReactComponent };